export function applyDefaultCredentials(credentials, defaultCredentials) {
    var _a, _b, _c;
    return {
        doInteractiveAuthentication: (_a = credentials.doInteractiveAuthentication) !== null && _a !== void 0 ? _a : defaultCredentials === null || defaultCredentials === void 0 ? void 0 : defaultCredentials.doInteractiveAuthentication,
        password: (_b = credentials.password) !== null && _b !== void 0 ? _b : defaultCredentials === null || defaultCredentials === void 0 ? void 0 : defaultCredentials.password,
        username: (_c = credentials.username) !== null && _c !== void 0 ? _c : defaultCredentials === null || defaultCredentials === void 0 ? void 0 : defaultCredentials.username,
    };
}
